import { Box, styled } from '@mui/material';
import { CollectionProductTitle } from '../CollectionProductItem/CollectionProductTitle';
import { CollectionProductStockStatus } from '../CollectionProductItem/CollectionProductStockStatus';
import { CollectionProductPrice } from '../CollectionProductItem/CollectionProductNetPrice';
import { ProductAddToCartButton } from '../../shared/ProductAddToCartButton';
import { CollectionProductImage } from '../CollectionProductItem/CollectionProductImage';
import { CollectionProductItemProps } from '../../../models/Collection';
import QuantityInputControlled from 'components/shared/QuantityInputControlled';
import { useForm } from 'react-hook-form';
import FlexBox from 'components/shared/FlexBox';

const StyledWrapper = styled(Box)(() => ({
    border: '1px solid #f5f5f5',
    borderRadius: '5px',
    paddingLeft: '10px',
    paddingRight: '10px',
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    columnGap: '24px',
}));

const StyledBox = styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    gap: '10px',
}));

const StyledImage = styled(Box)(() => ({
    width: '90px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    img: {
        maxWidth: '90px',
    },
}));

const StyledTitle = styled(Box)(({ theme }) => ({
    width: '60%',
    [theme.breakpoints.only('md')]: {
        width: '40%',
    },
    [theme.breakpoints.down('md')]: {
        width: '100%',
    },
}));

const StyledContent = styled(Box)(({ theme }) => ({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    [theme.breakpoints.down('md')]: {
        alignItems: 'start',
        flexDirection: 'column',
        width: '100%',
    },
}));

const StyledContainer = styled(Box)(({ theme }) => ({
    width: '100%',
    gap: '24px',
    display: 'flex',
    flexDirection: 'row',
    [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        gap: '12px',
    },
}));

const StyledActions = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
}));

export const CollectionListProductItem = (
    props: CollectionProductItemProps
) => {
    const { product, handle } = props;

    const { control, watch } = useForm({
        mode: 'onChange',
        defaultValues: { product },
    });

    const qty = watch(`product.qty`);

    return (
        <StyledWrapper>
            <StyledImage>
                <CollectionProductImage imageSrc={product.image} />
            </StyledImage>
            <StyledContent>
                <StyledTitle>
                    <CollectionProductTitle
                        product={product}
                        collectionHandle={handle}
                    />
                </StyledTitle>
                <StyledContainer>
                    <StyledBox>
                        <StyledBox
                            sx={{
                                justifyContent: 'end',
                            }}
                        >
                            <FlexBox gap={10} alignItems="flex-start">
                                <CollectionProductStockStatus
                                    quantity={product.stock}
                                />
                                <CollectionProductPrice price={product.price} />
                            </FlexBox>
                        </StyledBox>
                    </StyledBox>
                    <StyledActions>
                        <StyledBox
                            sx={{
                                minWidth: '120px',
                                maxWidth: '200px',
                                justifyContent: 'center',
                            }}
                        >
                            <QuantityInputControlled
                                control={control}
                                name={`product.qty`}
                                minOrderQuantity={product.minOrderQuantity}
                                minOrderMultiplier={
                                    product.minOrderMultiplier == 1
                                }
                                flat
                            />
                        </StyledBox>
                        <StyledBox
                            sx={{
                                justifyContent: 'end',
                            }}
                        >
                            <ProductAddToCartButton
                                variant={product.shopifyVariantId}
                                quantity={qty}
                                availableQty={product.quantityAvailable}
                            />
                        </StyledBox>
                    </StyledActions>
                </StyledContainer>
            </StyledContent>
        </StyledWrapper>
    );
};
